import React from 'react';
import {
  Button,
  makeStyles,
  TextField,
  Tooltip,
  Typography,
  CircularProgress,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import DynamicIcon from './DynamicIcon';
import SendRoundedIcon from '@material-ui/icons/SendRounded';
import { sendAmplitudeData } from 'util/amplitude';
import { InputWithIncrementDecrement } from 'components/DynamicScreen/CardWidgets/FormWidgets';
import { ArrowBackIos } from '@material-ui/icons';
import { persistentStore } from 'services/storage';

const useStyles = makeStyles({
  buttonRoot: {
    '&:hover': {
      backgroundColor: '#00bf8f',
    },
    background: '#00bf8f',
    borderRadius: 3,
    border: 0,
    color: 'white',
    fontSize: 16,
    fontWeight: 'bold',
  },
  label: {
    textTransform: 'capitalize',
  },
  hover: {},
  sansFont: {
    fontFamily: 'sans-serif',
  },
});

export default function Cart(props) {
  const { getItemValue, handleChange, isMobile, deliveryMode } = props;
  const classes = useStyles();
  const [buttonClicked, setButtonClicked] = React.useState(false);
  const { items, setCartItems, deleteCartDeeplink, cartPrice, setCartPrice } =
    props;
  const [formState, setFormState] = React.useState(() => []);
  const [selectedRadio, setSelectedRadio] = React.useState(
    (
      (deliveryMode &&
        deliveryMode.radio &&
        deliveryMode.radio.find((option) => option.selected)) ||
      {}
    ).value
  );

  React.useEffect(() => {
    items &&
      setFormState([
        ...items.map((item) => ({
          ...item,
          cartQty: item.cartQty || 1,
        })),
      ]);
    items && persistentStore.set('cartItems', items);
  }, [items]);

  const checkEmptyQty = () => {
    let empty = false;
    let message = '';
    for (let i = 0; i < formState.length; i++) {
      const element = formState[i];
      if (!element.cartQty) {
        empty = true;
        message = `Please fill valid quantity for ${element.title.title}!`;
        break;
      }
    }
    return [empty, message];
  };

  const placeOrder = () => {
    const [isEmpty, message] = checkEmptyQty();
    if (isEmpty) {
      alert(message);
    } else {
      setButtonClicked(true);
      const orderedItems = formState.map((item) => ({
        title: item.title,
        subtitle: item.subtitle,
        cartQty: item.cartQty,
        id: item.id,
        mrp: item.mrp,
      }));
      sendAmplitudeData(
        `${props.submitButtonText || 'Place Order'} Button Clicked`,
        {
          deep_link: props.placeOrderDeeplink.deeplink,
          formBody: {
            orderedItems,
            [deliveryMode && deliveryMode.formKey]: selectedRadio,
          },
          apiType: props.placeOrderDeeplink.apiType || 1,
        }
      );
      props.placeOrderDeeplink &&
      (props.placeOrderDeeplink.apiType === 1 ||
        !props.placeOrderDeeplink.apiType)
        ? props.setDeepLink(props.placeOrderDeeplink.deeplink)
        : props.placeOrderDeeplink &&
          props
            .handleDeeplink(
              props.placeOrderDeeplink.deeplink,
              props.placeOrderDeeplink.apiType,
              {
                items: formState,
                [deliveryMode && deliveryMode.formKey]: selectedRadio,
              }
            )
            .then((response) => {
              setButtonClicked(false);
              if (response) {
                setCartItems([]);
                setCartPrice(0);
                response.refreshDeeplink &&
                  (props.setDeepLink || (() => {}))(response.refreshDeeplink);
                response.userMessage && props.setMessage(response.userMessage);
              }
            });
    }
  };

  const getTotalItemPrice = (item) => {
    let filtered = formState.find((current) => current.id === item.id);
    return (
      filtered &&
      (
        (filtered.cartQty || 0) *
        parseFloat(filtered[props.calculationParameter] || filtered.mrp || 0)
      ).toFixed(2)
    );
  };

  const getTotalCartPrice = () => {
    let cartPrice = 0;
    formState.forEach(
      (element) =>
        (cartPrice +=
          (element.cartQty || 0) *
          parseFloat(element[props.calculationParameter] || element.mrp || 0))
    );
    return cartPrice.toFixed(2);
  };

  const deleteItem = (item) => {
    let remaining = formState.filter((element) => element.id !== item.id);
    item.deleteAction &&
      sendAmplitudeData('Item deleted from cart', {
        deep_link: item.deleteAction.deeplink,
        formBody: { deletedItem: item.title.title },
        apiType: item.deleteAction.apiType,
      });
    item.deleteAction &&
      props
        .handleDeeplink(
          item.deleteAction.deeplink,
          item.deleteAction.apiType || 2,
          item.id
        )
        .then((response) => {
          if (response) {
            response.refreshDeeplink &&
              props
                .handleDeeplink(response.refreshDeeplink)
                .then((response) => {
                  if (response) {
                    response.items && setCartItems(response.items);
                    response.totalAmount && setCartPrice(response.totalAmount);
                    response.userMessage &&
                      props.setMessage(response.userMessage);
                  }
                });
            response.userMessage && props.setMessage(response.userMessage);
          }
        });
  };

  return (
    <div
      style={{
        width: '100%',
        height: isMobile ? 'calc( 100vh - 56px )' : '100vh',
        backgroundColor: '#f9fbfd',
        paddingTop: 10,
        position: 'relative',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 10,
          }}
        >
          <div style={{ display: 'flex', marginLeft: 10 }}>
            {props.hasBackButton && (
              <IconButton
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                onClick={() => !!window && window.history.back()}
              >
                <ArrowBackIos />
              </IconButton>
            )}
            <Typography style={{ fontSize: 32, fontWeight: 'bold' }}>
              {props.title || 'My Cart'}
            </Typography>
          </div>

          {items && items.length > 0 && (
            <div>
              {!isMobile && props.deleteCartDeeplink && (
                <Tooltip
                  title={'Empty Cart'}
                  classes={{
                    tooltip: classes.tooltip,
                  }}
                >
                  <IconButton
                    onClick={() => {
                      props
                        .handleDeeplink(
                          deleteCartDeeplink.deeplink,
                          deleteCartDeeplink.apiType || 2,
                          {},
                          {
                            doneCallback: (refreshDeeplink) =>
                              props.setDeepLink(refreshDeeplink),
                          },
                          {
                            title: deleteCartDeeplink.promptMsg.title,
                            msg: deleteCartDeeplink.promptMsg.msg,
                          }
                        )
                        .then((response) => {
                          response &&
                            response.refreshDeeplink &&
                            props.setDeepLink(response.refreshDeeplink);
                          response &&
                            response.userMessage &&
                            props.setMessage(response.userMessage);
                        });
                    }}
                    style={{
                      backgroundColor: deleteCartDeeplink.color || '#FA4C5E',
                      borderRadius: 5,
                      color: '#ffffff',
                      width: 30,
                      height: 30,
                      marginRight: 5,
                      dilspay: 'flex',
                      alignItems: 'center',
                      padding: 20,
                      marginLeft: 10,
                    }}
                  >
                    <DynamicIcon
                      iconId={6}
                      style={{ height: 20, width: 20, color: '#ffffff' }}
                      insideColoredButton={true}
                    />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          height: isMobile ? 'calc(100vh - 240px)' : '85vh',
          maxHeight: isMobile ? 'calc(100vh - 240px)' : '85vh',
          overflow: 'auto',
        }}
      >
        {items && items.length > 0 ? (
          <>
            {items.map((item, index) => (
              <>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 8,
                    margin: 10,
                    padding: 8,
                    backgroundColor: '#ffffff',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      {item.title.title && (
                        <Typography
                          style={{
                            fontSize: isMobile ? 15 : 17,
                            color: '#000000',
                          }}
                        >
                          {item.title.title}
                        </Typography>
                      )}
                      {item.subtitle && (
                        <Typography
                          style={{
                            fontSize: isMobile ? 14 : 16,
                            color: '#000000',
                            opacity: 0.4,
                          }}
                        >
                          {item.subtitle}
                        </Typography>
                      )}
                    </div>
                    {item.offer && (
                      <div
                        style={{
                          display: 'flex',
                          width: '200px',
                        }}
                      >
                        <img
                          src="https://img.icons8.com/ios-glyphs/30/000000/discount.png"
                          style={{ width: 26, height: 26 }}
                          alt="offer"
                        />
                        <Typography
                          style={{
                            fontSize: 16.5,
                            color: '#289d92',
                            marginLeft: 10,
                            fontWeight: 'bold',
                          }}
                        >
                          {item.offer}
                        </Typography>
                      </div>
                    )}
                    <IconButton
                      aria-label="delete"
                      onClick={() => deleteItem(item)}
                    >
                      <img
                        src="https://img.icons8.com/material-outlined/24/000000/trash--v1.png”"
                        alt="delete"
                      />
                    </IconButton>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      margin: '10px 0 10px 0',
                    }}
                  >
                    <div style={{ width: '100px', paddingRight: 0 }}>
                      <InputWithIncrementDecrement
                        disableZeroInput={true}
                        minVal={1}
                        val={getItemValue(formState, item)}
                        handleChange={(value) =>
                          handleChange(
                            formState,
                            setFormState,
                            item,
                            parseInt(value)
                          )
                        }
                      />
                    </div>
                    <Typography
                      style={{
                        textAlign: 'right',
                        // width: '120px',
                        fontSize: isMobile ? 16 : 20,
                        color: '#000000',
                        opacity: 0.5,
                        fontWeight: 'normal',
                      }}
                      className={classes.sansFont}
                    >
                      {(item[props.calculationParameter] || item.mrp) && (
                        <>
                          {getItemValue(formState, item)}
                          &nbsp;&#10005;&nbsp;&#x20B9;
                          {item[props.calculationParameter] || item.mrp}
                        </>
                      )}
                    </Typography>
                    {
                      <Typography
                        style={{
                          textAlign: 'right',
                          // width: '120px',
                          fontSize: isMobile ? 16 : 20,
                          color: '#233C97',
                          fontWeight: 'bold',
                        }}
                        className={classes.sansFont}
                      >
                        {!!Number(getTotalItemPrice(item)) && (
                          <>
                            <span>&nbsp;&#8377;</span>
                            {Number(getTotalItemPrice(item)).toLocaleString(
                              'en-IN',
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </>
                        )}
                      </Typography>
                    }
                  </div>
                </div>
              </>
            ))}
          </>
        ) : (
          items && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                height: '100%',
              }}
            >
              <img
                src="https://cdn.pixabay.com/photo/2014/05/21/13/25/shopping-cart-349544_1280.png"
                style={{ height: 90, marginBottom: 50, objectFit: 'contain' }}
                alt="emptycart"
              />
              <Typography
                style={{ fontSize: isMobile ? 16 : 18 }}
                className={classes.sansFont}
              >
                Your cart seems to be empty 🙁
              </Typography>
            </div>
          )
        )}
      </div>
      <div
        style={{
          position: isMobile ? 'fixed' : 'absolute',
          width: '100%',
          bottom: 0,
        }}
      >
        {items && items.length > 0 && (
          <>
            {deliveryMode && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  padding: '0px 15px',
                  minWidth: '25vw',
                  maxWidth: '100%',
                  marginBottom: isMobile ? 4 : 10,
                  background: '#f9fbfd',
                }}
              >
                <Typography
                  style={{
                    fontWeight: 'bold',
                    fontSize: 16,
                    marginRight: 16,
                  }}
                >
                  {deliveryMode.title}
                </Typography>
                <RadioGroup
                  row={true}
                  value={selectedRadio}
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                  onChange={(e) => setSelectedRadio(e.target.value)}
                >
                  {deliveryMode &&
                    deliveryMode.radio &&
                    deliveryMode.radio.map((option) => (
                      <FormControlLabel
                        value={option.value || option.title}
                        control={
                          <Radio color="primary" className={classes.radio} />
                        }
                        label={option.title}
                      />
                    ))}
                </RadioGroup>
              </div>
            )}
            <div
              style={{
                display: 'flex',
                padding: isMobile ? '6px 10px' : 8,
                background: '#233C97',
                justifyContent: 'space-between',
                width: '100%',
                height: isMobile ? 66 : 84,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  style={{
                    fontSize: isMobile ? 14 : 16,
                    fontWeight: 600,
                    color: '#ffffff',
                    margin: isMobile ? '4px 0 0 5px' : '8px 0 0 5px',
                    letterSpacing: 'normal',
                  }}
                >
                  {formState.length} Items
                </Typography>
                <Typography
                  style={{
                    fontSize: isMobile ? 16 : 18,
                    fontWeight: 'bold',
                    color: '#ffffff',
                    margin: isMobile ? '5px 0 0 5px' : '10px 0 0 5px',
                    letterSpacing: 'normal',
                  }}
                >
                  {!!cartPrice && (
                    <>
                      &#8377;&nbsp;
                      {(Number(cartPrice) || 0).toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </>
                  )}
                </Typography>
              </div>
              <Button
                endIcon={<SendRoundedIcon />}
                style={{
                  color: '#ffffff',
                  fontWeight: 'bold',
                  fontSize: isMobile ? '17px' : '19px',
                }}
                disabled={buttonClicked}
                onClick={placeOrder}
              >
                {(buttonClicked && (
                  <CircularProgress
                    disableShrink={true}
                    thickness={5}
                    size={25}
                    style={{ color: '#ffffff' }}
                  />
                )) ||
                  props.submitButtonText ||
                  'Place Order'}
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
